import axios from 'axios';
import { WorkItemActionTypes } from './';

const endpoint = `${process.env.REACT_APP_ERP_API_HOST}/request/items`;

export function findWorkItems({ page, pageSize, order, ascDesc, search, name, code, referenceNum, isAssigned, assignedTo, workRequestName, workRequestReferenceNum , status, progress, type, verifiedBy, submittedBy, from, to, spectator, isLocked, isChecked }, callback, errorCallback) {
  let query = `?page=${page ? page : 1}&perPage=${pageSize ? pageSize : 20}`;

  if (order) query += `&order=${order}`;
  if (ascDesc) query += `&ascDesc=${ascDesc}`;
  if (search) query += `&search=${search}`;
  if (name) query += `&name=${name}`;
  if (code) query += `&code=${code}`;
  if (referenceNum) query += `&referenceNum=${referenceNum}`;
  if (isAssigned) query += `&isAssigned=${isAssigned}`;
  if (assignedTo) query += `&assignedTo=${assignedTo}`;
  if (workRequestName) query += `&workRequestName=${workRequestName}`;
  if (workRequestReferenceNum) query += `&workRequestReferenceNum=${workRequestReferenceNum}`;
  if (progress) query += `&progress=${progress}`;
  if (status) query += `&status=${status}`;
  if (type) query += `&type=${type}`;
  if (submittedBy) query += `&submittedBy=${submittedBy}`;
  if (verifiedBy) query += `&verifiedBy=${verifiedBy}`;
  if (from) query += `&from=${from}`;
  if (to) query += `&to=${to}`;
  if (spectator) query += `&spectator=${spectator}`;
  if (isLocked) query += `&isLocked=${isLocked}`;
  if (isChecked) query += `&isChecked=${isChecked}`;

  const request = axios.get(`${endpoint}${query}`);

  if (callback) {
      request.then((response) => callback(response));
  }

  if (errorCallback) {
      request.catch((error) => errorCallback(error));
  }

  return {
    type: WorkItemActionTypes.FIND,
    payload : request
  };
}

export function getWorkItemByReferenceNum(referenceNum, callback, errorCallback) {
  const request = axios.get(`${endpoint}/${referenceNum}`);

  if (callback) {
      request.then((response) => callback(response));
  }

  if (errorCallback) {
      request.catch((error) => errorCallback(error));
  }

  return {
    type: WorkItemActionTypes.GET,
    payload : request
  };
}

export function updateWorkItem(workItem, callback, errorCallback) {

  const request = axios.put(`${endpoint}/${workItem.referenceNum}`, workItem);

  if (callback) {
      request.then((response) => callback(response));
  }

  if (errorCallback) {
      request.catch((error) => errorCallback(error));
  }

  return {
    type: WorkItemActionTypes.UPDATE,
    payload: request
  }
}

export function patchWorkItem(workItem, callback, errorCallback) {
  const request = axios.patch(`${endpoint}/${workItem.referenceNum}`, workItem.patchData);

  if (callback) {
      request.then((response) => callback(response));
  }

  if (errorCallback) {
      request.catch((error) => errorCallback(error));
  }

  return {
    type: WorkItemActionTypes.PATCH,
    payload: request
  }
}

export function deleteWorkItem(referenceNum, callback, errorCallback) {

  const request = axios.delete(`${endpoint}/${referenceNum}`);

  if (callback) {
      request.then((response) => callback(response));
  }

  if (errorCallback) {
      request.catch((error) => errorCallback(error));
  }

  return {
    type: WorkItemActionTypes.DELETE,
    payload: request
  }

}

export function createWorkItem(workItem, callback, errorCallback) {

  const request = axios.post(`${endpoint}`, workItem);

  if (callback) {
      request.then((response) => callback(response));
  }

  if (errorCallback) {
      request.catch((error) => errorCallback(error));
  }

  return {
    type: WorkItemActionTypes.CREATE,
    payload: request
  }

}

export function executeWorkItems(workItems, callback, errorCallback) {

  const requests = workItems.map(i => {
    if (i.isDeleted) return  axios.delete(`${endpoint}/${i.referenceNum}`);
    if (i.referenceNum) return axios.put(`${endpoint}/${i.referenceNum}`, i);
    return axios.post(`${endpoint}`, i);
  });

  const mainRequest = axios.all(requests);

  if (callback) {
      mainRequest.then((response) => callback(response));
  }

  if (errorCallback) {
      mainRequest.catch((error) => errorCallback(error));
  }

  return {
    type: WorkItemActionTypes.EXECUTE_MULTIPLE,
    payload: mainRequest
  };
}

export function countWorkItems(type, callback, errorCallback) {
  let query = `?type=${type}`;

  const request = axios.get(`${endpoint}/count${query}`);

  if (callback) {
      request.then((response) => callback(response));
  }

  if (errorCallback) {
      request.catch((error) => errorCallback(error));
  }

  return {
    type: WorkItemActionTypes.COUNT,
    payload : request
  };
}



// WEBPACK FOOTER //
// ./src/actions/workitem.action.js